import {Component, Inject, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ProcessBuilderService} from "../../../services/process-builder.service";
import {Locale} from '../../../classes/locale';
import {ProcessTemplate} from "../../../classes/process-template";
import {FileImportTO} from "../../../classes/file-import-to";
import {ProcessTranslations} from "../../../classes/process-translations";

@Component({
  selector: 'app-process-translations',
  templateUrl: './process-translations.component.html',
  styleUrls: ['./process-translations.component.css']
})
export class ProcessTranslationsComponent implements OnInit {

  public fileImportTO: FileImportTO;

  translationsForm: FormGroup;
  languagesForm: FormGroup;
  languageFormArray: FormArray;
  control: FormArray;
  mode: boolean;
  touchedRows: any;

  languages: Locale[];

  // dataSource = new BehaviorSubject<AbstractControl[]>([]);
  dataSource: Locale[];

  locales: Locale[];

  // viewMode = 'languages';
  // title = 'Pick Languages';

  viewMode = 'translations';
  title = 'Define Translations';
  processTranslations: ProcessTranslations;

  constructor(
      public dialogRef: MatDialogRef<ProcessTranslationsComponent>,
      @Inject(MAT_DIALOG_DATA) public processTemplate: ProcessTemplate,
      private formBuilder: FormBuilder,
      private processBuilderService: ProcessBuilderService) {}

  setFileImportTO(fileImportTO: FileImportTO) {
    console.log('setFileImportTO');
    console.dir(fileImportTO);
    this.fileImportTO = fileImportTO;
    this.importTranslations();
  }

  ngOnInit(): void {
    this.touchedRows = [];
    this.translationsForm = this.formBuilder.group({
      translationRows: this.formBuilder.array([])
    });
    // this.addRow();

    console.log('ngOnInit.processTemplate:');
    console.dir(this.processTemplate);


    this.processBuilderService.getLocales().subscribe(locales => {
      this.locales = locales;

      // this.languageFormArray = this.formBuilder.array([])

      // this.locales.forEach(locale => {
      //   if (locale.code == 'en') locale.checked = true;
      //   if (locale.code == 'fr') locale.checked = true;
      // });

      // this.languagesForm = new FormGroup({
      //   languages: this.languageFormArray,
      // });

      if (this.processTemplate) {
        if (this.processTemplate.locales) {
          this.processTemplate.locales.forEach(templateLocale => {
            this.languages.push(templateLocale);
            this.locales.forEach(localeCheckForCheck => {
              if (localeCheckForCheck.code == templateLocale.code) {
                localeCheckForCheck.checked = true;
              }
            });
          });
        } else {
          this.locales.forEach(localeCheckForCheck => {
            if (localeCheckForCheck.code == this.processTemplate.localeCodeDefault) {
              localeCheckForCheck.checked = true;
            }
          });
        }
      }

      this.dataSource = locales;

      // this.updateView();

    });
  }

  // updateView() {
  //   this.dataSource.next(this.languageFormArray.controls);
  // }
  // private initLanguageItem(locale: Locale) {
  //   return this.formBuilder.group({
  //     id: [locale.id, []],
  //     code: [locale.code, []],
  //     name: [locale.name, []],
  //     checked: [locale.checked, []],
  //     highlighted: [locale.checked, []],
  //   })
  // }

  ngAfterOnInit() {
    this.control = this.translationsForm.get('translationRows') as FormArray;
  }

  initiateTranslations(locale: Locale): FormGroup {
    return this.formBuilder.group({
      localeCode: [locale.code],
      message: ['']
    });
  }

  initiateForm(): FormGroup {

    // const translationControl =  this.translationsForm.get('translationRows') as FormArray;
    // control.push(this.initiateForm());
    const translationsFormArray = this.formBuilder.array([])

    if (this.languages) {
      this.languages.forEach(locale => {
        translationsFormArray.push(this.initiateTranslations(locale))
      });
    }

    // this.languagesForm = new FormGroup({
    //   languages: this.languageFormArray,
    // });

    return this.formBuilder.group({
      key: [''],
      contextText: [''],
      translations: translationsFormArray,
      isEditable: [true]
    });
  }

  addRow() {
    const control =  this.translationsForm.get('translationRows') as FormArray;
    control.push(this.initiateForm());
  }

  deleteRow(index: number) {
    const control = this.translationsForm.get('translationRows') as FormArray;
    control.removeAt(index);
  }

  editRow(group: FormGroup) {
    group.get('isEditable').setValue(true);
  }

  doneRow(group: FormGroup) {
    group.get('isEditable').setValue(false);
  }

  saveUserDetails() {
    console.log(this.translationsForm.value);
  }

  get getFormControls() {
    const control = this.translationsForm.get('translationRows') as FormArray;
    return control;
  }

  // get getTranslationControls(translationRowControl: any) {
  //   const control = this.translationsForm.get('translationRows') as FormArray;
  //   return control;
  // }

  submitForm() {
    const control = this.translationsForm.get('translationRows') as FormArray;
    this.touchedRows = control.controls.filter(row => row.touched).map(row => row.value);
    console.log(this.touchedRows);
  }

  toggleTheme() {
    this.mode = !this.mode;
  }

  close() {
    console.log('close');
    this.dialogRef.close();
  }

  save() {
    console.log('save');
    console.dir(this.translationsForm.value);
    this.dialogRef.close(this.translationsForm.value);
  }

  onPickLanguages() {
    this.title = 'Pick Languages'
    this.viewMode = 'languages';
  }

  onTranslations() {
    this.title = 'Define Translations'
    this.viewMode = 'translations';

    this.languages = [];

    this.locales.forEach(locale => {
      if (locale.checked) {
        // console.log('locale checked: ' + locale.code);
        this.languages.push(locale);
      }

    });

  }

  // displayedColumns = ['checked', 'code'];
  displayedColumns = ['checked', 'code'];
  // displayedColumns = ['checked', 'position', 'name', 'weight', 'symbol'];
  // dataSource = ELEMENT_DATA;

  highlight(locale: Locale) {
    locale.highlighted = !locale.highlighted;
  }

  onLanguageChange(locale: Locale) {
    console.log('onLanguageChange.locale:');
    console.dir(locale);
  }

  private importTranslations() {
    console.log('%c importTranslations.processTemplate:', 'background: #222; color: #bada55');
    console.dir(this.processTemplate);
    if (this.processTemplate &&
        this.processTemplate.process &&
        this.processTemplate.process.formId &&
        this.processTemplate.process.key) {
      this.fileImportTO.formId = this.processTemplate.process.formId;
      this.fileImportTO.processKey = this.processTemplate.process.key;

      this.processBuilderService.importTranslations(this.fileImportTO).subscribe(processTranslations => {
        console.log('importTranslations complete!');
        console.dir(processTranslations);
        this.processTranslations = processTranslations;
        this.dialogRef.close(this.processTranslations);

      });
    } else {
      console.error("Failed to save translations; process not defined.");
    }
  }

  onExportTranslations() {
    if (this.processTemplate &&
        this.processTemplate.process &&
        this.processTemplate.process.formId &&
        this.processTemplate.process.key) {
      window.location.assign('/rest/form/export/translations?f=' + this.processTemplate.process.formId + '&p=' + this.processTemplate.process.key);
    }
  }
}
